import { REACT_APP_EXTERNAL_SIGN_IN } from "../../../config/constant";
import { clearDoorKey, wipeGuestData } from "../../../JS/wipeGuestData";
import { inAppBrowser } from "../../JS/inAppBrowser";

export const handlePreCheckInStorage = (CHECKIN_PQ_DATA) => {

    const current_connector_ip = localStorage.getItem("ConnectorIP") || sessionStorage.getItem("ConnectorIP") || process.env.REACT_APP_SERVER_IP;
    const clientId = localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG;

    let preCheckInDataHotelSpecificList = JSON.parse(localStorage.getItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST")) || [];

    let preCheckInData = {
        preCheckedInGuestInfo: CHECKIN_PQ_DATA || localStorage.getItem("X_CHECKIN_PQ_DATA") || "",
        connectorIP: current_connector_ip,
        clientId: clientId
    }

    let existingPreCheckinDataIndex = preCheckInDataHotelSpecificList.findIndex(item => item.clientId === clientId);
    if (existingPreCheckinDataIndex !== -1) {
        preCheckInDataHotelSpecificList[existingPreCheckinDataIndex] = preCheckInData;
    } else {
        preCheckInDataHotelSpecificList.push(preCheckInData);
    }

    localStorage.setItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(preCheckInDataHotelSpecificList));
}

export const isUserLoggedin=()=> {
        let room = localStorage.getItem("room");
        return room && room !== "null";
    };

export const isUserPreCheckedin=()=>{
        return localStorage.getItem("X_CHECKIN_PQ_DATA") ||  sessionStorage.getItem("X_CHECKIN_PQ_DATA")
    };


export const handleLocationSelect = async (props, hotelData, proceedLogginOutUser = false, callback, proceedEvenIfSameHotel=false ) => {

    if (!props || typeof props.setHotelSelectionAfterLoginState != "function" || typeof props.setLoader !== 'function' || typeof props.setGoHome !== 'function' || !props.menuColor) {    
        console.log("required props are missing")
        return;
    }

    if(Object.keys(hotelData).length == 0){
        return;
    }

    const current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();

    let room = localStorage.getItem("room");
    let rervationNO = localStorage.getItem("reservationNo");
    console.log(hotelData, "hotelData")

    if (hotelData.hotelPropertyKey == current_hotel_code && !proceedEvenIfSameHotel ) {
        callback(false);
    } else {
        if (hotelData.hotelIsAppSupported) {

          
            if(( isUserLoggedin() || isUserPreCheckedin()) && !proceedLogginOutUser && !(REACT_APP_EXTERNAL_SIGN_IN && props.externalSignIn.memberId)){
                props.setHotelSelectionAfterLoginState(true, hotelData)
                return;
            }
            
            handlePreCheckInStorage();

            props.setLoader(true, "Redirecting...", true, "redirecting_location")
            props.setHotelSelectionAfterLoginState(false)

            let clientId = hotelData.hotelPropertyKey != "" ? "GJ_" + hotelData.hotelPropertyKey : "";
            sessionStorage.setItem("ConnectorIP", hotelData.hotelServerBaseUrl);
            sessionStorage.setItem("clientId", clientId);

            localStorage.removeItem("ConnectorIP")
            localStorage.removeItem("clientId")

            if (rervationNO && rervationNO !== "null") {
                localStorage.setItem("reservationNo", "");
                await clearDoorKey();
            }

            sessionStorage.setItem("shownWelcomButton", true);

            props.setGoHome(true);

            if(props.externalSignIn && props.externalSignIn.memberId && window.device && window.device.platform != "Android"){
                let theKnowUserInfo = JSON.parse(localStorage.getItem("theKnowUserInfo"));
                theKnowUserInfo.isRedirected = true;
                localStorage.setItem("theKnowUserInfo",JSON.stringify(theKnowUserInfo));
            }

            setTimeout(() => {
                wipeGuestData({ inRoomTab: process.env.REACT_APP_INROOMTAB == "true" })
            }, 500);
        } else {
            inAppBrowser(hotelData.hotelServerBaseUrl, props, false, { displayName: "Hotel Selector", dontSetCurrentWidget: true })
        }
    }
}